import { StyleSheet } from 'react-native';
import theme from '../../../common/theme';
import { ThemeColors } from '../../../common/theme-colors';

const CONTENT_HEIGHT = 420;

export const getStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    container: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    content: {
      width: 500,
      flexDirection: 'row',
      alignItems: 'center',
      columnGap: 40,
      paddingVertical: 40,
      paddingHorizontal: 60,
      borderWidth: 1,
      borderColor: colors.border,
      borderRadius: theme.radius.l,
      backgroundColor: colors.elevation0,
      position: 'absolute',
    },
    lhs: {
      flex: 1,
      height: CONTENT_HEIGHT,
      rowGap: 48,
      alignItems: 'center',
      justifyContent: 'center',
    },
    header: {
      rowGap: 16,
    },
    text: {
      rowGap: 8,
    },
    amount: {
      fontSize: 28,
      lineHeight: 40,
      textAlign: 'center',
      color: colors.text,
      fontFamily: theme.fonts.semibold,
      fontVariant: ['tabular-nums'],
    },
    label: {
      fontSize: 14,
      lineHeight: 20,
      textAlign: 'center',
      color: colors.textLight,
      fontFamily: theme.fonts.medium,
      fontVariant: ['tabular-nums'],
    },
    title: {
      fontSize: 22,
      lineHeight: 30,
      textAlign: 'center',
      color: colors.text,
      fontFamily: theme.fonts.semibold,
    },
    btnText: {
      fontSize: 16,
      lineHeight: 22,
      textAlign: 'center',
      color: colors.neutral,
      fontFamily: theme.fonts.medium,
    },
    btn: {
      width: 160,
      height: 50,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: theme.radius.m,
      backgroundColor: colors.neutralL,
    },
  });
